import React from 'react'
import { TabsNavigation } from '../../components/navigations/tab'

export function HomeScreen({navigation, route}) {
  return (
    <TabsNavigation />
  )
}
